import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
import { mapDEPBResponse } from "@/redux/mappers/Export/CreateNewJob/DEPBMapper";
export const ProductDFIAApi = createApi({
  reducerPath: "productDFIAApi",
  baseQuery,
  tagTypes: ["productDFIA"],
  endpoints: (builder) => ({
    getProductDFIATableOne: builder.query({
      query: ({ id }) => `/export/product/dfia/${id}`,
      transformResponse: (response) => {
        return response?.data?.map((item,idx)=>{
          return {
            ...item,
            srNo: idx + 1,
            id: item.exportProductDFIAId,
          }
        }) ?? [];
      },
      providesTags: ["productDFIA"],
    }),

    createProductDFIATableOne: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/export/product/dfia/${id}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { exportProductDFIA: data },
      }),
      invalidatesTags: ["productDFIA"],
    }),

    updateProductDFIATableOne: builder.mutation({
      query: ({ id,subId, ...data }) => ({
        url: `/export/product/dfia/${id}/${subId}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { exportProductDFIA: data },
      }),
      invalidatesTags: ["productDFIA"],
    }),

    deleteProductDFIATableOne: builder.mutation({
      query: ({ id }) => ({
        url: `/export/product/dfia/${id}`,
        method: "DELETE",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
      }),
      invalidatesTags: ["productDFIA"],
    }),
      createProductDFIATableTwo: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/export/product/dfia/item/${id}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { exportProductDFIAItem: data },
      }),
      invalidatesTags: ["productDFIA"],
    }),

    updateProductDFIATableTwo: builder.mutation({
      query: ({ id, subId, ...data }) => ({
        url: `/export/product/dfia/item/${id}/${subId}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { exportProductDFIAItem: data },
      }),
      invalidatesTags: ["productDFIA"],
    }),


    deleteProductDFIATableTwo: builder.mutation({
      query: ({ id }) => ({
        url: `/export/product/dfia/item/${id}`,
        method: "DELETE",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
      }),
      invalidatesTags: ["productDFIA"],
    }),

    getProductDFIATableTwo: builder.query({
      query: ({ id }) => `/export/product/dfia/item/${id}`,
      transformResponse: (response) => {
        const data = response?.data ?? [];
        const normalized = Array.isArray(data) ? data : [data];

        return normalized.map((item,idx) => ({
          ...item,
          srNo: idx + 1,
          id: item.exportDFIAItemId,
        }));
      },
      providesTags: ["productDFIA"],
    }),
  }),
});

export const {
  useLazyGetProductDFIATableOneQuery,
  useCreateProductDFIATableOneMutation,
  useUpdateProductDFIATableOneMutation,
  useDeleteProductDFIATableOneMutation,
  useCreateProductDFIATableTwoMutation,
  useLazyGetProductDFIATableTwoQuery,
  useUpdateProductDFIATableTwoMutation,
  useDeleteProductDFIATableTwoMutation,
} = ProductDFIAApi;
